import { Box, Link, Typography } from "@mui/material";

const Footer = () => {
  return (
    <Box sx={{ textAlign: "center" }}>
      <footer>
        <Typography variant="caption">
          The art of
          <Link
            href="#"
            sx={{
              color: "#CFFAFE",
              mx: 1,
              textDecoration: "none",
            }}
          >
            "rojak" design
          </Link>
          by Amirah Nasihah
          <Typography component="span" sx={{ ml: 1 }}>
            🖌️🍽️
          </Typography>
        </Typography>
      </footer>
    </Box>
  );
};

export default Footer;
